<template>
    <div class="sub_contents">
        <div class="cont_center">
            <h2 class="title_page">MY PAGE</h2>

            <p class="sub_descript">
                고객님의 개인정보 및 활동 내역을 확인하실 수 있습니다.
            </p>

            <div class="mypage_area personal">
                <ul class="sub_link_list">
                    <li>
                        <RouterLink to="/HFO_MP_003">1:1 문의 내역</RouterLink>
                    </li>
                    <li class="on">
                        <RouterLink to="/HFO_MP_005">개인정보관리</RouterLink>
                    </li>
                </ul>

                <p class="mypage_descript">고객님의 회원 정보를 변경 및 관리 할 수 있습니다.</p>

                <ul class="tab_list tab_col_4">
                    <li>
                        <RouterLink to="/HFO_MP_005">회원정보 <br class="pc_none">변경</RouterLink>
                    </li>
                    <li>
                        <RouterLink to="/HFO_MP_006">비밀번호 <br class="pc_none">변경</RouterLink>
                    </li>
                    <li>
                        <RouterLink to="/HFO_MP_007">마케팅정보 <br class="pc_none">수신동의</RouterLink>
                    </li>
                    <li class="on">
                        <RouterLink to="/HFO_MP_008">회원 탈퇴</RouterLink>
                    </li>
                </ul>

                <div class="login_box_area">
                    <!-- <h3 class="title_login">
                        Hi-Vitamin<br>Membership
                    </h3> -->

                    <div class="login_input_area">
                        <p class="join_descript">
                            회원탈퇴 전 유의사항을 꼭 확인해 주세요.
                        </p>

                        <div class="memberout_area">
                            <h4 class="title_out">탈퇴 사유 선택</h4>

                            <div class="memberout_check_area">
                                <CheckBox v-for="option in memberOut" :key="option.value" :id="option.value"
                                    :value="option.value" :label="option.label" v-model="selectedOptions" />
                            </div>

                            <h4 class="title_out">기타 의견 입력</h4>

                            <div class="etc_out_area">
                                <TextArea :placeholder="placeholdertextarea" :maxlength="500"></TextArea>
                            </div>

                            <h4 class="title_out">회원탈퇴 유의사항 </h4>

                            <ul class="memberout_info_txt">
                                <li>탈퇴 시 결제 내역 및 등 모든 회원 활동 정보가 삭제되므로 탈퇴 전 다시 한번 신중히 고민 후 진행하시기 바랍니다.</li>
                                <li>동일한 휴대폰번호로 재가입 하여도 이전 이용 내역을 확인하실 수 없습니다.</li>
                            </ul>

                            <div class="btn_login_area">
                                <button class="btn_type2">취소</button>
                                <button class="btn_type2">확인</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CheckBox from '@/components/CheckBox'
import TextArea from '@/components/TextArea'

export default {
    components: {
        CheckBox,
        TextArea
    },
    data() {
        return {
            memberOut: [
                {
                    label: '자주 이용하지 않음',
                    value: 'out1'
                },
                {
                    label: '새로운 계정으로 재가입',
                    value: 'out2'
                },
                {
                    label: '서비스에 대한 불만족',
                    value: 'out3'
                },
                {
                    label: '서비스 이용의 어려움',
                    value: 'out4'
                },
                {
                    label: '기타',
                    value: 'out5'
                }
            ],
            placeholdertextarea: '상세 사유를 입력해주세요.(선택)'
        }
    },
    methods: {

    }
}
</script>